import { Fieldset, FormControl, Input, InputOption, Select } from "@visa/vds";
import EmailRegrex from "_constants/EmailValidationRegrex";
import EmailValidationRegrex from "_constants/EmailValidationRegrex";
import { DEFAULT_COUNTRY_CODE } from "_constants/GlobalConstants";
import { FormHelper } from "_helpers/FormHelper";
import MCSControlInput from "components/MCSControlInput";
import MCSControlSelect from "components/MCSControlSelect";
import { useAuthContextUser } from "context/AuthContext";
import "flag-icon-css/css/flag-icon.min.css";
import React from "react";

const ContactSection = ({ isReadOnly, errors, register, control, sectionName, updateFormData, countries, getValues }) => {


  return (
    <>
      <Fieldset>
        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            label="First Name*"
            name={sectionName + ".firstName"}
            handleChange={updateFormData}
            rules={{
              required: true,
              maxLength: 100,
            }}
          />
        </FormControl>
        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            label="Last Name*"
            name={sectionName + ".lastName"}
            handleChange={updateFormData}
            rules={{
              required: true,
              maxLength: 100,
            }}
          />
        </FormControl >
        <FormControl position="left" space="fifty">
          <MCSControlInput
            control={control}
            register={register}
            readOnly={isReadOnly}
            label="Business Title"
            name={sectionName + ".businessTitle"}
            handleChange={updateFormData}
            rules={{
              maxLength: 100,
            }}
          />
        </FormControl>
        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            label="Business Email*"
            name={sectionName + ".email"}
            handleChange={updateFormData}
            type="email"
            rules={{
              required: true,
              maxLength: 100,
              validate: {
                validEmailFormat: (v) => EmailRegrex.validEmailFormat.test(v),
                corporateEmail: (v) => EmailRegrex.coporateEmail.test(v),
              }
            }}
          />
          { }
        </FormControl>
        <FormControl position="left" space="fifty">
          {!isReadOnly
            ? <MCSControlSelect
              name={sectionName + ".countryCode"}
              register={register}
              control={control}
              label="Country"
              handleChange={updateFormData}
              options={
                <>
                  <option value="" selected>
                    - Select -
                  </option>
                  {countries && countries.map((country, k) => (
                    <option key={k} value={country.id}>
                      {country.countryName.trim()}
                    </option>
                  ))}
                </>
              }
            />
            : <Select label="Country" readOnly={true} value={countries.find(x => x.id == getValues(sectionName).countryCode)?.countryName} />

          }
        </FormControl>

        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            register={register}
            label="Business Phone Number"
            name={sectionName + ".phoneNumber"}
            handleChange={updateFormData}
            rules={{
              maxLength: 100,
            }}
          />
        </FormControl>
      </Fieldset>
    </>
  )
};

export default ContactSection;